import React from 'react';
import styled from '../index.module.scss';
import { useQuestionStore, useQuestionDispatch } from '../../QuestionProvider';
import { useGlobal } from '@/utils/useGlobal';
import Button from '@/components/UI/Button';
import { textLang } from '../../../textLang';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';

interface ExamFooterProps {
    submit: () => void;
    finshed: () => void;
    answer: string;
}

const ExamFooter: React.FC<ExamFooterProps> = ({ submit, finshed, answer }) => {
    const { index, question, loading, questionInfo } = useQuestionStore();
    const { defAnswer, questionName, optionList } = question[index];
    const dispatch = useQuestionDispatch();
    const { locale } = getLocal();
    const lang = textLang[locale as string] || textLang.us;

    const answerName = React.useMemo(() => {
        if (answer) {
            const target: any = optionList.find((item) => item.optionId === answer);
            if (target) return target.optionSelect;
        }
        return '';
    }, [answer, optionList]);

    const handleNext = (index: number) => {
        dispatch({
            type: 'changeIndex',
            payload: index,
        });
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'option_select',
                title_name: `${questionInfo ? questionInfo.campaignName : ''}_${questionName}`,
                button_name: lang.prev,
                position: answerName,
            });
        } catch (err) {}
    };

    const handleSubmit = () => {
        const btnName = !defAnswer ? lang.submit : lang.next;
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'option_select',
                title_name: `${questionInfo ? questionInfo.campaignName : ''}_${questionName}`,
                button_name: btnName,
                position: answerName,
            });
        } catch (err) {}
        if (!defAnswer) return submit();
        if (index === question.length - 1) return finshed();

        handleNext(index + 1);
    };

    return (
        <div className={styled.exam_footer}>
            <Button className="back" disabled={index <= 0} aria-label={'back'} onClick={() => handleNext(index - 1)}>
                {lang.prev}
            </Button>
            <Button className="confrim" aria-label={lang.prev} disabled={!answer && !defAnswer} onClick={handleSubmit} loading={loading}>
                {!defAnswer ? lang.submit : lang.next}
            </Button>
        </div>
    );
};

export default ExamFooter;
